/// Open module params
export default {
  EligibilityCheckEnabled: 'LoanEnquiryEligibilityCheckEnabled',
  RedirectToLoginPage: 'LoanEnquiryRedirectToLoginPage', 
  AllowFromOutsideCommonBond: 'LoanEnquiryAllowFromOutsideCommonBond',
  AllowedFileExtensions: 'LoanEnquiryAllowedFileExtensions', 
  PreviousAddressRequiredInYears: 'LoanEnquiryPreviousAddressRequiredInYears',
  LoanAppExpenditureMinItemsConfirmation: 'LoanAppExpenditureMinItemsConfirmation',
  HidePostcodeCheck: 'LoanEnquiryHidePostcodeCheck',
  RedirectUnregisteredUserUrl: 'LoanEnquiryRedirectUnregisteredUserUrl',
  PaymentStepValue: 'LoanEnquiryPaymentStepValue',
  PaymentStepEnabled: 'LoanEnquiryPaymentStepEnabled',
  PaymentStepTestMode: 'LoanEnquiryPaymentStepTestMode',
  PaymentStepServiceUrl: 'LoanEnquiryPaymentStepServiceUrl',
  PaymentStepInstallationId: 'LoanEnquiryPaymentStepInstallationId',
  PaymentStepCardsUrl: 'LoanEnquiryPaymentStepCardsUrl',
  PaymentStepItemDescription: 'LoanEnquiryPaymentStepItemDescription',
  ExpiredTokenRedirectUrl: 'ExpiredTokenRedirectUrl',

  // PB.SystemSettings
  MinimumAge: 'MinAge',
  UseLoanDetailDescription: 'UseLoanDetailDescription'
};